import { render, staticRenderFns } from "./Domains.vue?vue&type=template&id=b18cea00&scoped=true&"
import script from "./Domains.vue?vue&type=script&lang=ts&"
export * from "./Domains.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18cea00",
  null
  
)

export default component.exports